import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';
import { SocialShareModal } from 'redux/modules/modal/types';

export default function useSocialShareConnectedModal() {
  return useConnectedModal<SocialShareModal>('SocialShare');
}
